import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '~gql';

export const PUBLIC_SPOT = graphql(`
  query PublicSpot($id: ID!) {
    publicSpot(spotIDoLID: $id) {
      id
      linkId
      name
      description
      address
      type
      coordinates {
        latitude
        longitude
      }
      images {
        id
        url
      }
      event {
        scheduledAt
        locationName
      }
      business {
        hours {
          day
          openTime
          closeTime
        }
      }
      groups {
        id
        linkId
        title
        scheduledAt
        memberCount
        maxSize
        visibility
        genderPolicy
        ageRange {
          min
          max
        }
        members {
          id
          hidden
          avatarUrl
          initials
        }
      }
    }
  }
`);

export type PublicSpotData = ResultOf<typeof PUBLIC_SPOT>;
export type PublicSpotVars = VariablesOf<typeof PUBLIC_SPOT>;
export type PublicSpotDetail = NonNullable<PublicSpotData['publicSpot']>;
export type PublicSpotImage = PublicSpotDetail['images'][number];
export type PublicSpotGroup = PublicSpotDetail['groups'][number];
export type PublicSpotGroupMember = PublicSpotGroup['members'][number];
export type PublicBusinessHour = NonNullable<
  NonNullable<PublicSpotDetail['business']>['hours']
>[number];
